import CurrentUser from 'src/types/CurrentUser';

export function userHasEmailSuffix(
  user: CurrentUser | undefined,
  suffix: string,
): boolean {
  const emails = user?.emails ?? [];
  const normalizedSuffix = suffix.toLowerCase();
  return emails.some(
    (email) =>
      typeof email === 'string' &&
      email.toLowerCase().endsWith(normalizedSuffix),
  );
}

// DO NOT USE THIS FUNCTION, USE isGentlyAIUserInCurrentView INSTEAD
export function isGentlyAIUser(user: CurrentUser | undefined): boolean {
  return user?.isAdmin ?? false;
}

/**
 * Checks if user should be treated as a GentlyAI user based on their actual role
 * and current view mode. Admins can switch to end-user view, but end-users
 * are always treated as end-users.
 */
export function isAdmin(
  user: CurrentUser | undefined,
  viewMode: 'admin' | 'enduser' = 'admin',
): boolean {
  const actuallyAdmin = isGentlyAIUser(user);

  // If not actually an admin, always treat as end-user
  if (!actuallyAdmin) {
    return false;
  }

  // If admin but in end-user view mode, treat as end-user
  if (viewMode === 'enduser') {
    return false;
  }

  // Admin in admin view mode
  return true;
}
